import { render, staticRenderFns } from "./ProjectFormMultimedia.vue?vue&type=template&id=0635e7b9"
import script from "./ProjectFormMultimedia.vue?vue&type=script&lang=ts"
export * from "./ProjectFormMultimedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports